import React, { useEffect, useMemo } from "react"
import { graphql } from "gatsby"
import useEventQuery from "../../../hooks/use-event-query"
import EventCard from "../../cards/event"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import { Link } from "../../../../plugins/gatsby-plugin-atollon"
import Select from "react-select"
import sal from 'sal.js'

const types = [
  { value: "", label: "All Event Types" },
  { value: "corporate", label: "Corporate" },
  { value: "social", label: "Social" },
  { value: "wedding", label: "Wedding" },
  { value: "other", label: "Other" },
]

const guestsOptions = [
  { value: "", label: "All No. Guests" },
  { value: "0-20", label: "0 - 20" },
  { value: "20-100", label: "20 - 100" },
  { value: "100-200", label: "100 - 200" },
  { value: "200-1000", label: "200+" },
]

const seatsOptions = [
  { value: "", label: "All Options" },
  { value: "seated", label: "Seated" },
  { value: "standing-/-cocktail", label: "Standing / Cocktail" },
  { value: "accessible", label: "Accessible" },
]

const AvailableSpace = ({ title, filter, richContent, button }) => {
  const events = useEventQuery()
  const [type, setType] = React.useState()
  const [seated, setSeated] = React.useState()
  const [numberOfGuests, setNumberOfGuests] = React.useState()

  const filteredEvents = useMemo(() => {
    let filtered = events

    if (type) {
      filtered = filtered.filter(el =>
        el.categories.some(cat =>
          cat.title.split(' ').join('-').toLowerCase() === type
        )
      )
    }

    if (seated) {
      filtered = filtered.filter(el =>
        el.categories.some(cat =>
          cat.title.split(' ').join('-').toLowerCase() === seated
        )
      )
    }

    if (numberOfGuests) {
      filtered = filtered.filter(el => {
        // split numberOfGuests into int seperateed by -
        const [min, max] = numberOfGuests.split('-').map(Number)
        if (max) {
          return (el.seats >= min && el.seats <= max) || (el.stands >= min && el.stands <= max)
        }
      })
    }

    return filtered
  }, [type, seated, numberOfGuests, events])

  useEffect(() => {
    sal()
  }, [filteredEvents])

  return (
    <section className="available-space">
      <div className="available-space__inner">
        {
          filter &&
          <div className="available-space__filter" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
            <div className="available-space__title">
              {title && <h2>{parse(title)}</h2>}
              <div className="filter">
                <form>
                  <div className="form__select">
                    <Select
                      options={types}
                      id="types"
                      name="types"
                      onChange={(e) => setType(e.value)}
                      placeholder="Event Type"
                      classNamePrefix="react-select"
                      className="react-select"
                    />
                    <Select
                      id="guests"
                      name="guests"
                      options={guestsOptions}
                      onChange={(e) => setNumberOfGuests(e.value)}
                      placeholder="No. of Guests"
                      classNamePrefix="react-select"
                      className="react-select"
                    />
                    <Select
                      id="seated"
                      name="seated"
                      options={seatsOptions}
                      onChange={(e) => setSeated(e.value)}
                      placeholder="Seated or Standing"
                      classNamePrefix="react-select"
                      className="react-select"
                    />
                  </div>
                </form>
              </div>
            </div>
            <div className="available-space__content">
              {richContent && <StructuredText data={richContent} />}
              {
                button?.length > 0 &&
                <Link
                  className="btn btn--border"
                  to={button[0].link[0].externalLink ? button[0].link[0].externalLink : button[0].link[0].internalLink.permalink}>
                  {button[0].title}
                </Link>
              }
            </div>
          </div>
        }
        <div className="available-space__items">
          {
            filteredEvents?.length > 0 && filteredEvents.map((el, i) => (
              <EventCard key={i} {...el} />
            ))
          }
        </div>
      </div>
    </section>
  )
}

export default AvailableSpace

export const query = graphql`
  fragment AvailableSpaceProps on DatoCmsAvailableSpace {
    ... on DatoCmsAvailableSpace {
      id
      title
      filter
      richContent {
        value
      }
      button {
        ...LinkWithTitleProps
      }
    }
  }
`